import type { ReadonlyDeep } from 'type-fest';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosRequestConfig, isCancel } from 'axios';

import * as apiRequestsHelpers from '@/helpers/api/requests';
import {
  // validateAcceptedStatusReqConf,
  // validateCreatedStatusReqConf,
  // validateNoContentStatusReqConf,
  validateOKStatusReqConf,
  // validateOKn404StatusReqConf,
} from '@/helpers/fetchers';
import {
  showErrorNotification,
  showSuccessNotification,
} from '@/helpers/notifiers';
// import { sendWarning } from '@/helpers/sentry';

export async function fetchGetSmsDailyHistory(
  params: openapi.GetSmsDailyHistory_Query,
  requestConfig: AxiosRequestConfig = {},
): Promise<openapi.GetSmsDailyHistory_200> {
  try {
    const res = await apiRequestsHelpers.getSmsDailyHistory(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting the list of SMS messages',
      });
    }
    throw err;
  }
}

export async function fetchGetSmsMessagesDaily(
  params: openapi.GetSmsMessagesDaily_Query,
  requestConfig: AxiosRequestConfig = {},
): Promise<openapi.GetSmsMessagesDaily_200> {
  try {
    const res = await apiRequestsHelpers.getSmsMessagesDaily(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting the list of SMS messages',
      });
    }
    throw err;
  }
}

export async function fetchGetSmsMessagesHistory(
  params: openapi.GetSmsMessagesHistory_Query,
  requestConfig: AxiosRequestConfig = {},
): Promise<openapi.GetSmsMessagesHistory_200> {
  try {
    const res = await apiRequestsHelpers.getSmsMessagesHistory(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting the list of SMS messages',
      });
    }
    throw err;
  }
}

export async function fetchPostSmsMessagesMarkRead(
  params: ReadonlyDeep<openapi.PostSmsMessagesMarkRead_Query>,
  data: ReadonlyDeep<openapi.PostSmsMessagesMarkRead_Body>,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): Promise<openapi.PostSmsMessagesMarkRead_200> {
  try {
    const res = await apiRequestsHelpers.postSmsMessagesMarkRead(params, data, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error marking all unread messages in a conversation as read',
      });
    }
    throw err;
  }
}

export async function fetchPostSmsMessagesSend(
  params: ReadonlyDeep<openapi.PostSmsMessagesSend_Query>,
  data: ReadonlyDeep<openapi.PostSmsMessagesSend_Body>,
  requestConfig: Readonly<AxiosRequestConfig> = {},
): Promise<openapi.PostSmsMessagesSend_200> {
  try {
    const res = await apiRequestsHelpers.postSmsMessagesSend(params, data, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    showSuccessNotification({
      text: 'Your SMS message was successfully sent',
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({ title: 'Error sending the SMS message' });
    }
    throw err;
  }
}

export async function fetchGetSmsMessagesConversations(
  params: openapi.GetSmsMessagesConversations_Query,
  requestConfig: AxiosRequestConfig = {},
): Promise<openapi.GetSmsMessagesConversations_200> {
  try {
    const res = await apiRequestsHelpers.getSmsMessagesConversations(params, {
      ...validateOKStatusReqConf,
      ...requestConfig,
    });
    return res.data;
  } catch (err) {
    if (!isCancel(err)) {
      showErrorNotification({
        title: 'Error getting the list of SMS conversations',
      });
    }
    throw err;
  }
}
